import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { PromiseSection } from './components/PromiseSection';
import { IdentificationSection } from './components/IdentificationSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { useScrollFadeIn } from './hooks/useScrollFadeIn';
const PIXEL_ID = '759566727183941';
export function App() {
  useScrollFadeIn();
  useEffect(() => {
    // Inject Meta Pixel script
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', PIXEL_ID);
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Hero data-id="element-2" />
      <PromiseSection data-id="element-3" />
      <IdentificationSection data-id="element-4" />
      <ProblemSection data-id="element-5" />
      <MechanismSection data-id="element-6" />
      <ProductSection data-id="element-7" />
      <BonusSection data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <PricingSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}